"use client";

import { Menu } from "@base-ui/react/menu";
import { cn } from "@/lib/utils";

const DropdownMenu = Menu.Root;

type DropdownMenuActions = Menu.Root.Actions;

const DropdownMenuTrigger = Menu.Trigger;

type PositionerProps = React.ComponentProps<typeof Menu.Positioner>;

function DropdownMenuContent({
  align,
  className,
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof Menu.Popup> & {
  align?: PositionerProps["align"];
  sideOffset?: PositionerProps["sideOffset"];
}) {
  return (
    <Menu.Portal>
      <Menu.Positioner align={align} className="z-50" sideOffset={sideOffset}>
        <Menu.Popup
          className={cn(
            "popup-surface popup-motion max-h-(--available-height) min-w-32 overflow-y-auto overflow-x-hidden rounded-xl p-1 text-gray-1200 outline-hidden",
            className
          )}
          {...props}
        />
      </Menu.Positioner>
    </Menu.Portal>
  );
}

type DropdownMenuItemVariant = "default" | "destructive";

const itemVariants: Record<DropdownMenuItemVariant, string> = {
  default:
    "hover-hover:hover:bg-gray-300 focus:bg-gray-300 focus:text-gray-1200 [&_svg:not([class*='text-'])]:text-gray-1000",
  destructive:
    "text-red-500 hover-hover:hover:bg-red-500/10 focus:bg-red-500/10 focus:text-red-500 [&_svg:not([class*='text-'])]:text-red-500",
};

function DropdownMenuItem({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<typeof Menu.Item> & {
  variant?: DropdownMenuItemVariant;
}) {
  return (
    <Menu.Item
      className={cn(
        "relative flex cursor-pointer select-none items-center gap-2 rounded-lg px-2 py-1.5 text-sm outline-hidden data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
        itemVariants[variant],
        className
      )}
      {...props}
    />
  );
}

export type { DropdownMenuActions };
export {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
};
